<div
  class="read-word-dialog-container"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <div class="read-word-word-dialog">
    <!-- ! Errors -->
    <div *ngIf="_deletedField">
      <div class="alert alert-success success-msg">
        <div>
          <ng-lottie width="30px" [options]="options"></ng-lottie>
        </div>
        <div *ngIf="_deleteFromDDC">&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been deleted.</div>
        <div *ngIf="_deleteFromDic">&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been removed from dictionary.</div>
      </div>
    </div>
    <div class="word-type-priv" *ngIf="!_deletedField">
      <ddc-text-gradient
        class="text-2xl"
        [_icon]="'fiber_smart_record'"
        [_text]="'Pair'"
        [_type]="'1'"
      ></ddc-text-gradient>
      <!-- ! Privacy -->
      <ddc-privacy [code]="_selectedPrivacyChipOptions" [withText]="false"></ddc-privacy>
    </div>
    <mat-divider style="margin-bottom: 10px; margin-top: 10px"></mat-divider>
    <!-- ! Pair Container -->
    <div class="add-dialog-container" *ngIf="!_deletedField">
      <!-- ! Infos -->
      <div class="alert alert-danger" *ngIf="_editError">
        {{ _editError }}
      </div>
      <div *ngIf="_editedField">
        <div class="alert alert-success success-msg">
          <div>
            <ng-lottie width="30px" [options]="options"></ng-lottie>
          </div>
          <div>&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been edited.</div>
        </div>
      </div>
      <!-- ! Language -->
      <div class="add-dialog-row-1 add-dialog-lng">
        <ddc-country-flag [ddc_lng]="_selectedLanguage" [has_label]="true"></ddc-country-flag>
      </div>
      <!-- ! Article, Word, Pos -->
      <div class="word-dialog-row">
        <div class="word-art" *ngIf="_selectedArticle" matTooltip="Article">{{ _selectedArticle }}</div>
        <!-- Word -->
        <div class="word-word">{{ _selectedWord }}</div>
        <!-- POS -->
        <div class="word-pos" *ngIf="_selectedPos" matTooltip="Part of Speech">{{ _selectedPos }}</div>
      </div>
      <div class="word-dialog-row">
        <div class="word-art" *ngIf="_selectedArticle2" matTooltip="Article">{{ _selectedArticle2 }}</div>
        <!-- Word -->
        <div class="word-word">{{ _selectedWord2 }}</div>
        <!-- POS -->
        <div class="word-pos" *ngIf="_selectedPos2" matTooltip="Part of Speech">{{ _selectedPos2 }}</div>
      </div>
      <!-- ! Language -->
      <div class="add-dialog-row-1 add-dialog-lng">
        <ddc-country-flag [ddc_lng]="_selectedLanguage2" [has_label]="true"></ddc-country-flag>
      </div>
      <mat-divider style="margin-bottom: 10px; margin-top: 10px"></mat-divider>
      <div class="word-cat-tag">
        <!-- ! Category 1-->
        @if (_selectedCategory && _selectedCategory.length > 0) {
          <div class="word-cat">
            <ddc-category-s [label]="_selectedCategory[0].label"></ddc-category-s>
          </div>
        }
        <!-- ! Category 2-->
        @if (_selectedCategory2 && _selectedCategory2.length > 0) {
          <div class="word-cat">
            <ddc-category-s [label]="_selectedCategory2[0].label"></ddc-category-s>
          </div>
        }
        <!-- ! Tags 1 -->
        <ddc-tag-s
          class="word-tag"
          *ngIf="_selectedTags && _selectedTags?.length"
          [tags]="_selectedTags | slice: 0 : 3"
        ></ddc-tag-s>
        <!-- ! Tags 2 -->
        <ddc-tag-s
          class="word-tag"
          *ngIf="_selectedTags2 && _selectedTags2?.length"
          [tags]="_selectedTags2 | slice: 0 : 3"
        ></ddc-tag-s>
      </div>

      <!-- ! Definitions-->
      <ddc-country-flag
        *ngIf="_selectedDefinition || _selectedExample"
        [ddc_lng]="_selectedLanguage"
        [has_label]="false"
      ></ddc-country-flag>
      <ddc-definition *ngIf="_selectedDefinition" [text]="_selectedDefinition"></ddc-definition>
      <ddc-example *ngIf="_selectedExample" [text]="_selectedExample"></ddc-example>
      <!-- ! Examples-->
      <ddc-country-flag
        *ngIf="_selectedDefinition2 || _selectedExample2"
        [ddc_lng]="_selectedLanguage2"
        [has_label]="false"
      ></ddc-country-flag>
      <ddc-definition *ngIf="_selectedDefinition2" [text]="_selectedDefinition2"></ddc-definition>
      <ddc-example *ngIf="_selectedExample2" [text]="_selectedExample2"></ddc-example>
      <!-- ! Dictionary 1 -->
      <ddc-dics [elements]="_selectedDics?.length ? _selectedDics : []"></ddc-dics>
    </div>
    <!-- ! Footer -->
    <mat-divider style="margin-bottom: 10px; margin-top: 20px"></mat-divider>
    <div class="read-word-dialog-submit-container">
      <div class="read-word-dialog-submit-container-right">
        <!-- Cancel -->
        <button class="read-word-dialog-close-btn" mat-button type="button" (click)="closeDialog()">Close</button>
      </div>
      <div class="read-word-dialog-submit-container-left"></div>
    </div>
  </div>
</div>
